




























import VueApexCharts from "vue-apexcharts";
import { Vue, Component, Watch } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";
import { CategoryChartSeries } from "../../models/category-chart-data";
import { RecogAndVolumeChartData } from "../../models/recognition-volume-data";
import { invoiceAnalyticsService } from "../../services/analytics.service";
import RecognitionAnalyticsStore from "../../store/recognition-analytics.store";

@Component({
  components: { apexchart: VueApexCharts }
})
export default class RecogBySupplierChart extends Vue {
  private loadingHeaderFieldRecogData = false;
  private readonly recognitionStore: RecognitionAnalyticsStore = getModule(
    RecognitionAnalyticsStore,
    this.$store
  );
  get recogBySupplierData() {
    return this.recognitionStore.getRecogBySupplierData;
  }
  get supplierInvoiceVolumeData() {
    return this.recognitionStore.getSupplierInvoiceVolumeData;
  }
  get dateRange() {
    return this.recognitionStore.getDateRange;
  }
  get selectedSite() {
    return this.recognitionStore.getSelectedSite;
  }
  get searchButtonClicked() {
    return this.recognitionStore.getSearchButtonClicked;
  }
  get includeVsInRecogRates() {
    return this.recognitionStore.getIncludeVsInRecogRates;
  }
  private series: CategoryChartSeries[] = [];
  private headerRecogSeries: CategoryChartSeries[] = [];
  private chartOptions = {
    chart: {
      id: "recogBySupplier",
      fontFamily: "'Lato', sans-serif",
      toolbar: {
        export: {
          csv: {
            filename: `recognition-by-supplier-${this.dateRange.startDate}-to-${this.dateRange.endDate}`,
            columnDelimiter: ",",
            headerCategory: "Supplier"
          }
        }
      },
      events: {
        dataPointSelection: async (e: any, chart: any, opts: any) => {
          const recogBySupplierChart = document.querySelector(
            "#recog-by-supplier"
          );
          const headerRecogChartForSupplier = document.querySelector(
            "#header-recog-for-supplier"
          );

          if (opts.selectedDataPoints[0]) {
            if (
              opts.selectedDataPoints[0].length === 1 &&
              headerRecogChartForSupplier != null &&
              headerRecogChartForSupplier.classList.contains("active")
            ) {
              this.updateHeaderRecogChart(chart, "headerRecogChartForSupplier");
            } else if (
              opts.selectedDataPoints[0].length === 1 &&
              headerRecogChartForSupplier != null &&
              recogBySupplierChart != null
            ) {
              recogBySupplierChart.classList.add(
                "header-recog-chart-activated"
              );
              headerRecogChartForSupplier.classList.add("active");
              this.updateHeaderRecogChart(chart, "headerRecogChartForSupplier");
            }
          }

          if (
            recogBySupplierChart != null &&
            headerRecogChartForSupplier != null &&
            opts.selectedDataPoints[0]
          ) {
            if (opts.selectedDataPoints[0].length === 0) {
              recogBySupplierChart.classList.remove(
                "header-recog-chart-activated"
              );
              headerRecogChartForSupplier.classList.remove("active");
            }
          }
        }
      }
    },
    dataLabels: {
      enabled: false
    },
    states: {
      normal: {
        filter: {
          type: "desaturate"
        }
      },
      active: {
        allowMultipleDataPointsSelection: false,
        filter: {
          type: "darken",
          value: 0.25
        }
      }
    },
    plotOptions: {
      bar: {
        horizontal: false
      }
    },
    yaxis: [
      {
        title: {
          text: "Recognition Rate (%)"
        },
        min: 0,
        max: 100,
        labels: {
          formatter: function(value: number) {
            if (value) {
              return Math.floor(value);
            }
          }
        }
      },
      {
        opposite: true,
        title: {
          text: "Percent of Total Invoices Entered"
        },
        min: 0,
        max: 100,
        labels: {
          formatter: function(value: number) {
            if (value) {
              return Math.floor(value);
            }
          }
        }
      }
    ],
    xaxis: {
      type: "category",
      title: {
        text: "Supplier"
      },
      labels: {
        formatter: (value: any) => {
          if (value.length) {
            const supplierIdIndex = value.lastIndexOf("/");
            return value.substring(supplierIdIndex + 1);
          }
        }
      }
    },
    title: {
      text: "Recognition Rate by Supplier",
      align: "left"
    },
    subtitle: {
      text: "Top 20 suppliers by quantity of invoices entered",
      align: "left"
    },
    tooltip: {
      shared: false,
      followCursor: true,
      x: {
        formatter: function(value: any) {
          if (value.length) {
            const supplierIdIndex = value.lastIndexOf("/");
            return value
              .substring(0, supplierIdIndex - 1)
              .concat(` (${value.substring(supplierIdIndex + 1)})`);
          }
        }
      },
      y: {
        formatter: function(value: any) {
          if (value) {
            return value.toString().concat("%");
          }
        }
      }
    },
    noData: {
      text: "No data for selected options",
      align: "center"
    }
  };

  private headerRecogChartOptions = {
    chart: {
      id: "headerRecogForSelectedSupplier",
      type: "bar",
      fontFamily: "'Lato', sans-serif",
      toolbar: {
        export: {
          csv: {
            filename: `selected-supplier-header-field-recognition-${this.dateRange.startDate}-to-${this.dateRange.endDate}`,
            columnDelimiter: ",",
            headerCategory: "Field"
          }
        }
      }
    },
    plotOptions: {
      bar: {
        horizontal: true,
        distributed: true
      }
    },
    dataLabels: {
      enabled: true
    },
    title: {
      text: "Recognition Rate by Field",
      align: "left"
    },
    subtitle: {
      text: "Selected supplier",
      align: "left"
    },
    yaxis: {
      title: {
        text: "Header Field"
      },
      min: 0,
      max: 100
    },
    xaxis: {
      type: "category",
      title: {
        text: "Recognition Rate (%)"
      }
    },
    colors: [
      "#07445b",
      "#49547b",
      "#77677a",
      "#bf9856",
      "#e28b44",
      "#d46b4f",
      "#bb5055",
      "#9e3a58",
      "#7c285a"
    ],
    legend: {
      show: false
    },
    tooltip: {
      y: {
        formatter: function(value: any) {
          if (value) {
            return value.toString().concat("%");
          }
        }
      }
    },
    noData: {
      text: "No data for selected options",
      align: "center"
    }
  };

  async created() {
    if (this.recogBySupplierData.length === 0) {
      await this.fetchNewChartData();
    }
    this.updateChart();
    this.$emit("chartLoaded");
  }

  async fetchNewChartData() {
    // hide drill-down chart
    const headerRecogChartForSupplier = document.querySelector(
      "#header-recog-for-supplier"
    );
    if (headerRecogChartForSupplier != null) {
      headerRecogChartForSupplier.classList.remove("active");
    }

    if (this.selectedSite !== "") {
      const chartData: RecogAndVolumeChartData = await invoiceAnalyticsService.loadRecogBySupplierDataAsync(
        this.selectedSite,
        this.dateRange.startDate,
        this.dateRange.endDate,
        "",
        "",
        this.includeVsInRecogRates
      );
      this.recognitionStore.updateRecogBySupplierData(chartData.recognition);
      this.recognitionStore.updateSupplierInvoiceVolumeData(chartData.volume);
    } else {
      this.recognitionStore.updateRecogBySupplierData([]);
      this.recognitionStore.updateSupplierInvoiceVolumeData([]);
    }
  }

  updateChart() {
    this.series = [
      {
        name: "Recognition rate",
        data: this.recogBySupplierData.slice(0, 20),
        color: "#07445b"
      },
      {
        name: "Percent of total invoices entered",
        data: this.supplierInvoiceVolumeData.slice(0, 20),
        color: "#D06C49"
      }
    ];
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  async updateHeaderRecogChart(sourceChart: any, destChartIDToUpdate: any) {
    if (sourceChart.w.globals.selectedDataPoints[0]) {
      if (this.selectedSite !== "") {
        this.loadingHeaderFieldRecogData = true;

        const substringStartIndex = sourceChart.w.globals.labels[
          sourceChart.w.globals.selectedDataPoints[0][0]
        ].lastIndexOf("/");

        const selectedSupplierId = sourceChart.w.globals.labels[
          sourceChart.w.globals.selectedDataPoints[0][0]
        ].substring(substringStartIndex + 1);

        const headerRecogData = await invoiceAnalyticsService.loadRecogByHeaderDataAsync(
          this.selectedSite,
          this.dateRange.startDate,
          this.dateRange.endDate,
          "supplierid",
          selectedSupplierId,
          this.includeVsInRecogRates
        );

        this.headerRecogSeries = [
          {
            name: "recognition rate",
            data: await headerRecogData
          }
        ];

        this.headerRecogChartOptions = {
          ...this.headerRecogChartOptions,
          subtitle: {
            text: `${sourceChart.w.globals.labels[
              sourceChart.w.globals.selectedDataPoints[0][0]
            ].substring(
              0,
              substringStartIndex
            )} (${sourceChart.w.globals.labels[
              sourceChart.w.globals.selectedDataPoints[0][0]
            ].substring(substringStartIndex + 1)}) for selected date range`,
            align: "left"
          }
        };

        this.loadingHeaderFieldRecogData = false;
      }
    }
  }

  @Watch("searchButtonClicked")
  async updateSearch() {
    await this.fetchNewChartData();
    this.updateChart();
    this.$emit("chartLoaded");
  }
}
